module.exports = __webpack_public_path__ + "static/3-Tri-09-d927ba8fc1105645741cb3cdffc14ca1.png";